// @flow

import * as React from 'react';
import { Flex, Box, useSystem } from 'react-system';
import * as icons from '../icons';
import { useTheme } from '../theme';
import { useLocale } from '../hooks/locale.js';
import { Center } from '../controls/Center';
import { SectionHeading } from '../controls/section-heading';

export const JoinReasonsSection = (): React.Node => {
  const { pt, mx, mb } = useSystem();
  const { t } = useLocale();
  const { text, colors } = useTheme();

  const bgImage = value => ({ backgroundImage: value });
  const textAlign = value => ({ textAlign: value });
  const maxWidth = value => ({ maxWidth: value });

  return (
    <div css={bgImage('linear-gradient(180deg, #f6f9ff 0, #fff 50%)')}>
      <Center css={pt(5)}>
        <SectionHeading align="center">{t('joinReasonsTitle')}</SectionHeading>
        <Flex
          // $FlowFixMe[speculation-ambiguous] - pnpm peer resolution makes flow ambiguous on react-system MediaProp<T> arrays
          flexDirection={['column', 'row']}
          // $FlowFixMe[speculation-ambiguous] - pnpm peer resolution makes flow ambiguous on react-system MediaProp<T> arrays
          alignItems={['center', 'flex-start']}
          justifyContent="space-around"
          css={textAlign('center')}
        >
          <Box px={2} mb={5} css={maxWidth(260)}>
            <icons.Telescope
              size={70}
              fill={colors.primaryMain}
              css={[mx('auto'), mb(4)]}
            />
            <h3 css={[text.h6, mb(4)]}>{t('joinReasonsSubtitle1')}</h3>
            <p css={text.body1}>{t('joinReasonsText1')}</p>
          </Box>
          <Box px={2} mb={5} css={maxWidth(260)}>
            <icons.Rocket
              size={70}
              fill={colors.primaryMain}
              css={[mx('auto'), mb(4)]}
            />
            <h3 css={[text.h6, mb(4)]}>{t('joinReasonsSubtitle2')}</h3>
            <p css={text.body1}>{t('joinReasonsText2')}</p>
          </Box>
          <Box px={2} mb={5} css={maxWidth(260)}>
            <icons.Astronaut
              size={70}
              fill={colors.primaryMain}
              css={[mx('auto'), mb(4)]}
            />
            <h3 css={[text.h6, mb(4)]}>{t('joinReasonsSubtitle3')}</h3>
            <p css={text.body1}>{t('joinReasonsText3')}</p>
          </Box>
        </Flex>
      </Center>
    </div>
  );
};
